/* eslint-disable compat/compat */
import { renderHenter, renderSokeresultat } from './resultat/sokeresultat.html'
import { apiUrl, emneknaggList, emneknaggUrl } from '../../../navigation'
import { name, version } from '../../../../package.json'
import { getElementTag } from '@nrk/dh-server-libs/get-element-tag'

const tag = getElementTag(name, version)

export class SexguidenSok extends HTMLElement {
  /*
  static get observedAttributes() {
    return ['data-emneknagger']
  }
   */

  connectedCallback() {
    // Remember original state for history api
    const originalState = { valgteEmneknagger: this.emneknaggElement.valgteEmneknagger }
    window.onpopstate = (e) => {
      const state = e.state || originalState
      this.emneknaggElement.valgteEmneknagger = state.valgteEmneknagger
      this._logTagsChanged()
      this._updateResults()
    }

    this.addEventListener('dh-sexguiden-emneknagger-updated', this._handleEmneknaggerUpdated)
  }

  _handleEmneknaggerUpdated = () => {
    this._updateHistory()
    this._logTagsChanged()
    this._updateResults()
  }

  _logTagsChanged() {
    const valgteEmneknagger = this.emneknaggElement.valgteEmneknagger
    this.appElement.sendGaEvent({
      eventAction: 'TAGS-CHANGED',
      eventLabel: emneknaggList(valgteEmneknagger),
    })
  }

  _updateHistory() {
    try {
      const valgteEmneknagger = this.emneknaggElement.valgteEmneknagger
      window.history.pushState(
        { valgteEmneknagger },
        '',
        emneknaggUrl(this.baseUrl, valgteEmneknagger)
      )
    } catch {
      // Not possible to set history in google translated page
    }
  }

  async _updateResults() {
    // Abort active requests
    if (this._abortController) {
      this._abortController.abort()
    }
    const emneknaggElement = this.emneknaggElement
    const valgteEmneknagger = emneknaggElement.valgteEmneknagger
    const sok = { valgteEmneknagger, emneknagger: emneknaggElement.alleEmneknagger }
    this.resultsElement.innerHTML = renderHenter(sok)

    this._abortController = new AbortController()
    const signal = this._abortController.signal
    try {
      const response = await fetch(apiUrl(this.baseUrl, sok), {
        signal,
        mode: 'no-cors',
      })
      const { stillinger, emneknagger } = await response.json()
      sok.stillinger = stillinger
      sok.emneknagger = emneknagger
      emneknaggElement.alleEmneknagger = emneknagger

      this.setAttribute('updated', '')
      this.resultsElement.innerHTML = renderSokeresultat(
        sok,
        emneknaggElement.alleEmneknagger,
        this.baseUrl
      )
    } catch (e) {
      if (valgteEmneknagger !== emneknaggElement.valgteEmneknagger) {
        // Emneknagger has changed since request was sent
      } else {
        this.resultsElement.innerHTML = 'En feil oppstod'
      }
    }

    delete this._abortController
  }

  get appElement() {
    return this.closest(tag)
  }

  get resultsElement() {
    return this.querySelector('[data-results]')
  }

  get baseUrl() {
    return this.getAttribute('data-base-url')
  }

  /*
   * Attributes
   * */

  get emneknaggElement() {
    return this.querySelector('dh-sexguiden-emneknagger')
  }

  get images() {
    return this.querySelectorAll('img')
  }
}
